export default {"src":"/_next/static/media/thunder.57198391.svg","height":22,"width":16,"blurWidth":0,"blurHeight":0};